import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Component, ElementRef, Injector, Type } from "@angular/core";
import { trigger, state, animate, transition, style } from "@angular/animations";
import { BfxRiskTradeContextMenuService } from "./services/bfx-risk-trade-contextmenu.service";
import { BfxBaseBlotterContextMenu } from "../bfx-base-blotter/bfx-base-blotter-contextmenu";

import { LoggerService } from "@bfx/logger";

import {
  LimitRiskTradePrimaryLookupService,
  AlgoRiskTradePrimaryLookupService,
  BMRiskTradePrimaryLookupService,
} from "../../shared/cubiq-services/lookup/model/impl/RiskTradePrimaryLookupService";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-risk-trade-context-menu",
  templateUrl: "./html/bfx-risk-trade-contextmenu.html",
  animations: [
    trigger("showHideMenu", [
      state("show", style({ opacity: 1 })),
      state("hide", style({ opacity: 0 })),
      transition("show => hide", animate("100ms ease-in")),
      transition("hide => show", animate("100ms ease-out")),
    ]),
  ],
  standalone: false,
})
export class BfxRiskTradeContextMenuComponent extends BfxBaseBlotterContextMenu<CubiqTS.DealImpl> {
  constructor(
    injector: Injector,
    limit: LimitRiskTradePrimaryLookupService,
    algo: AlgoRiskTradePrimaryLookupService,
    bm: BMRiskTradePrimaryLookupService,
    elementRef: ElementRef,
  ) {
    super(injector, [limit, algo, bm], elementRef);
  }

  protected getMenuServiceType(): Type<BfxRiskTradeContextMenuService> {
    return BfxRiskTradeContextMenuService;
  }
}
